// EventData.js
const eventData = [
    {
      id: 1,
      title: 'Yugal Kunj Classes',
      image: 'https://yugalkunj.org/images/Ca_yugalkunjclasses.jpg',
      modalImage: 'https://yugalkunj.org/images/Ca_yugalkunjclasses.jpg',
      showFlyer: true
    },

    {
      id: 2,
      title: 'Weekly Satsangs',
      image: 'https://yugalkunj.org/images/satsang.jpg',
      modalImage: 'https://yugalkunj.org/images/satsang.jpg',
      showFlyer: true
    },
    {
      id: 3,
      title: 'Inauguration Events',
      image: 'https://yugalkunj.org/images/YUGAL%20KUNJ%20CANADA%20PRAN%20PRATISHTHA_page-0001.jpg',
      link: '/CAD/InaugurationEvents',
      showFlyer: false
    },

      {
        id: 4,
        title: 'Global Seva Mission 2025',
        image: 'https://yugalkunj.org/images/Gmission-2025.png',
        modalImage: 'https://yugalkunj.org/images/Gmission-2025.png',
        showFlyer: true
      },

  ];
  
  export default eventData;
  